'use strict';
const _ = require('underscore'),
	observable = require('@mindmup/mapjs-core/src/util/observable');

module.exports = function MeasuresModel(measuresContent, mapModel, defaultFilter) {
	if (!measuresContent || !mapModel) {
		throw 'invalid-args';
	}
	let labelledMeasure,
		filter,
		latestMeasurementValues = [],
		latestMeasures = [],
		selectedMeasure,
		isActive = false;

	const self = observable(this),
		labelGeneratorName = 'measures',
		getLatestMeasureNames = function () {
			return (latestMeasures.length && latestMeasures) || measuresContent.getMeasuresNames();
		},
		getContext = function () {
			const measures = getLatestMeasureNames(),
				selectedExistingMeasure = _.contains(measures, selectedMeasure) && selectedMeasure,
				labelledExistingMeasure = _.contains(measures, labelledMeasure) && labelledMeasure,
				hasLabelledSelected = selectedExistingMeasure && labelledExistingMeasure && (labelledExistingMeasure === selectedExistingMeasure),
				canLabelSelected = !hasLabelledSelected && selectedExistingMeasure,
				hasMeasures = !!(measures && measures.length);
			return {
				isActive: isActive,
				selectedMeasure: selectedExistingMeasure,
				hasSelection: !!selectedExistingMeasure,
				hasMeasures: hasMeasures,
				labelledMeasure: labelledExistingMeasure,
				canLabelSelected: !!canLabelSelected,
				hasLabelledSelected: !!hasLabelledSelected
			};
		},
		dispatchContext = function () {
			self.dispatchEvent('measuresContext', getContext());
		},
		dispatchMeasuresChangeEvents = function () {
			const measures = measuresContent.getMeasuresNames();
			if (self.listeners('measureRemoved').length > 0) {
				_.each(_.difference(latestMeasures, measures), function (measure) {
					self.dispatchEvent('measureRemoved', measure);
				});
			}

			if (self.listeners('measureAdded').length > 0) {
				_.each(_.difference(measures, latestMeasures), function (measure) {
					self.dispatchEvent('measureAdded', measure, measures.indexOf(measure));
				});
			}
			latestMeasures = measures;
			if (!selectedMeasure && latestMeasures && latestMeasures.length) {
				self.setSelectedMeasure(latestMeasures[0]);
			}

		},
		onFilterChanged = function () {
			self.dispatchEvent('measureRowsChanged');
			dispatchContext();
		},
		mapMeasurements = function (measurements) {
			const map = {};
			_.each(measurements, function (measurement) {
				map[measurement.id] = measurement;
			});
			return map;
		},
		measurementValueDifferences = function (measurement, baseline) {
			const difference = [];
			_.each(measurement.values, function (value, key) {
				const baselineValue = (baseline && baseline.values && baseline.values[key]) || 0;
				if (value !== baselineValue) {
					difference.push(['measureValueChanged', measurement.id, key, value || 0]);
				}
			});
			if (baseline) {
				_.each(baseline.values, function (value, key) {
					const noNewValue = !measurement || !measurement.values || !measurement.values[key];
					if (noNewValue) {
						difference.push(['measureValueChanged', baseline.id, key, 0]);
					}
				});
			}
			return difference;
		},
		measurementDifferences = function (measurements, baslineMeasurements) {
			/*{id: 11, title: 'with values', values: {'Speed': 1, 'Efficiency': 2}}*/
			const baslineMeasurementsMap = mapMeasurements(baslineMeasurements);
			let differences = [];
			_.each(measurements, function (measurement) {
				const baseline = baslineMeasurementsMap[measurement.id];
				differences = differences.concat(measurementValueDifferences(measurement, baseline));
			});
			return differences;
		},
		dispatchMeasurementChangedEvents = function () {
			if (self.listeners('measureValueChanged').length === 0) {
				return;
			}
			const oldMeasurementValues = latestMeasurementValues,
				differences = measurementDifferences(self.getMeasurementValues(), oldMeasurementValues);
			_.each(differences, function (changeArgs) {
				self.dispatchEvent.apply(self, changeArgs);
			});
		};
	self.getTitle = function () {
		return measuresContent.getTitle();
	};
	self.editingMeasure = function (isEditing, nodeId) {
		if (isEditing && nodeId) {
			mapModel.selectNode(nodeId, true, true);
		}
		mapModel.setInputEnabled(!isEditing, true);

		self.dispatchEvent('measureEditing', isEditing, nodeId);
	};
	self.getMeasures = function () {
		return measuresContent.getMeasuresNames();
	};
	self.setActive = function (active) {
		const wasActive = isActive;
		isActive = active;
		if (active && !wasActive) {
			latestMeasures = measuresContent.getMeasuresNames();
			self.getMeasurementValues();
			if (!selectedMeasure && latestMeasures && latestMeasures.length) {
				self.setSelectedMeasure(latestMeasures[0]);
			}
		}
		dispatchContext();
	};
	self.setSelectedMeasure = function (measureName) {
		selectedMeasure = measureName;
		dispatchContext();
	};
	self.getSelectedMeasure = function () {
		return selectedMeasure;
	};
	self.editWithFilter = function (newFilter) {
		if (filter) {
			self.removeFilter();
		}
		filter = newFilter;
		if (filter && filter.addEventListener) {
			filter.addEventListener('filteredRowsChanged', onFilterChanged);
		}
	};
	self.addUpMeasurementForAllNodes = function (measurementName) {
		return measuresContent.addUpMeasurementForAllNodes(measurementName);
	};
	self.getMeasurementValues = function () {
		const result = measuresContent.getMeasurementValues(filter);
		latestMeasurementValues = result.slice(0);
		return result;
	};
	self.addMeasure = function (measureName) {
		const added = measuresContent.addMeasure(measureName);
		if (added) {
			self.setSelectedMeasure(added);
		}
		return added;
	};
	self.removeMeasure = function (measureName) {
		const result = measuresContent.removeMeasure(measureName);
		if (selectedMeasure === result) {
			selectedMeasure = false;
		}
		return result;
	};
	self.removeSelectedMeasure = function () {
		const context = getContext();
		if (!context.hasSelection) {
			return;
		}
		self.removeMeasure(context.selectedMeasure);
	};
	self.labelMeasure = function (measure) {
		if ((!labelledMeasure && !measure) ||
			(labelledMeasure === measure) ||
			(measure && !_.contains(getLatestMeasureNames(), measure))) {
			return false;
		}
		if (measure) {
			mapModel.setLabelGenerator(function () {
				return self.addUpMeasurementForAllNodes(measure);
			});
		} else {
			mapModel.setLabelGenerator(false);
		}
		labelledMeasure = measure;
		dispatchContext();
		return true;
	};
	self.labelSelectedMeasure = function () {
		if (!selectedMeasure) {
			return false;
		}
		return self.labelMeasure(selectedMeasure);
	};
	self.validate = function (value) {
		return !isNaN(parseFloat(value)) && isFinite(value);
	};
	self.setValue = function (nodeId, measureName, value) {
		return measuresContent.setValue(nodeId, measureName, value);
	};
	self.getRawData = function (ignoreFilter) {
		const dataFilter = !ignoreFilter && filter;
		return measuresContent.getRawData(dataFilter);
	};
	self.removeFilter = function () {
		if (filter && filter.cleanup) {
			filter.cleanup();
		}
		if (filter && filter.removeEventListener) {
			filter.removeEventListener('filteredRowsChanged', onFilterChanged);
		}
		filter = undefined;
	};
	self.showAddMeasure = function () {
		self.dispatchEvent('showAddMeasure');
	};
	mapModel.addEventListener('labelGeneratorChange', function (setter) {
		if (setter !== labelGeneratorName) {
			labelledMeasure = false;
			dispatchContext();
		}
	});
	measuresContent.addEventListener('measures-new-content-loaded', () => {
		latestMeasures = measuresContent.getMeasuresNames();
		self.getMeasurementValues();
		self.dispatchEvent('startFromScratch');
	});
	measuresContent.addEventListener('measures-content-changed', function () {
		if (isActive) {
			dispatchMeasuresChangeEvents();
			dispatchMeasurementChangedEvents();
			dispatchContext();
		}
	});
	self.editWithFilter(defaultFilter);
};


